export const Routes = {
  API_HOSTNAME: "https://www.portal.measervices.in",
  WEBSOCKET_HOSTNAME: "wss://www.portal.measervices.in:8081",
  API_HOSTNAME_WP: "https://api.wapmonkey.com",
  INSERTLEAD: "insert-lead",
  GETUSERBYID: "get-userbyid",
};
